<template>
  <Card class="users-education__progress">
    <div class="users-education__progress-header">
      <span>Прогресс</span>
      <span>160 из 800 очков</span>
    </div>
    <ProgressLine type="success" :percentage="30" />
  </Card>
</template>

<script>
import Card from '@/components/Common/Card'
import ProgressLine from '@/components/Common/Progress'

export default {
  name: 'Progress',
  components: {
    Card,
    ProgressLine
  }
}
</script>

<style scoped lang="scss">
.users-education__progress {
  display: flex;
  flex-direction: column;
  margin-top: 24px;

  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    font-weight: 500;
    font-size: 15px;
    letter-spacing: 0.2px;
    color: $deepdark;
  }
}
</style>
